module.exports = __webpack_public_path__ + "img/29.509438a0.jpg";